import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useUpdateSharedResources(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `
        mutation updateSharedResourcesStatus($sharedResourceIds: [ID]!, $status: SupportedSharedResourceStatus!) {
            updateSharedResourcesStatus(sharedResourceIds: $sharedResourceIds, status: $status) {
              successMessage
            }
        }`;

    const resolver = (resp) => {
      return { data: resp.data.updateSharedResourcesStatus };
    };

    return { query, resolver };
  }, []);

  const [updateSharedResources, { loading }] = useMutationWithToaster(
    mutationFactory,
    { onDone }
  );

  return {
    isUpdating: loading,
    updateSharedResources: async (sharedResourceIds, status) => {
      return updateSharedResources(
        {
          sharedResourceIds: sharedResourceIds,
          status: status,
        },
        {
          successMsg: `Successfully ${status.toLowerCase()} shared resources`,
          defaultErrorMsg: `Failed to ${status.toLowerCase()} shared resources. Please retry or contact support for assistance.`,
        }
      );
    },
  };
}

export default useUpdateSharedResources;
